import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssignPracticeQuestionStudyMaterialComponent } from '../../question-management/assign-practice-question-study-material/assign-practice-question-study-material.component';

@Component({
  selector: 'app-content-studymaterial-list',
  templateUrl: './content-studymaterial-list.component.html',
  styleUrls: ['./content-studymaterial-list.component.css']
})
export class ContentStudymaterialListComponent implements OnInit {
  @Input() StudyMaterialresponse: any;
  @Output() Editstudymaterial : EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private cdr: ChangeDetectorRef,
    private ngModalService: NgbModal,
  ) { }

  ngOnInit() {
    console.log(this.StudyMaterialresponse,'StudyMaterialresponse');
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  EditButton(data:any){
   this.Editstudymaterial.emit(data);

  }
  AssignPracticeQuestions(studyMaterial:any)
  {
    
    const modalRef = this.ngModalService.open(AssignPracticeQuestionStudyMaterialComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'custom-modal-width-relation',
    });
    
    modalRef.componentInstance.studyMaterial = studyMaterial;
    
  }
}
